module.exports = __webpack_public_path__ + "img/hea_team_medicine.b1b59d83.png";